import React, { FC, useContext, useState } from "react";
import { Button, Row, Col, Badge, Menu, Dropdown, Spin /*, Input*/ , Select} from "antd";
import {find , debounce} from 'lodash';
import BellIcon from "@assets/icon_Bell.svg";
import Bell from "@assets/icon_Bell.svg";
import "./header.scss";
import authService from "@services/auth.service";
import useSession from "@utils/useSession";
import { useNavigate } from "react-router-dom";
// import { routeMap } from "@utils/constants";

import { UploadContext } from "../../context/uploadProvider";
import { appInsights } from "../../appInsights";
import sessionService from "@services/session.service";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { useIdleTimerContext } from "react-idle-timer";
import { GLOBAL_SEARCH_DROPDOWN_KEY, routeMap } from "@utils/constants";
import SimpleSelect from "@components/simpleSelect/simpleSelect";
import { useHelperApiFunctions } from "@utils/customHooks";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import { SearchOutlined } from '@ant-design/icons';
import membersService from "@services/members.service";
import DataNotFound from '@components/noDataFound';
import { NO_DATA_FOUND } from "../../constants/constants";
import { showHeaderGlobalSearchAndNotification } from "@utils/helpers";

type HeaderProps = {
  logo: any;
  companyName: string;
  userName: string;
  newNotificationFlag?: boolean;
  actionClickHandler?: any;
};

const Header: FC<HeaderProps> = ({ logo, companyName, userName, newNotificationFlag, actionClickHandler }: HeaderProps) => {
  const { setIsLogout, isUpload } = useContext(UploadContext);

  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();

  const session = useSession();
  const idleTimer = useIdleTimerContext();
  const [membersOptions, setMembersOptions] = useState<any>([]);
  const [searchMembersInputString, setSearchMembersInputString] = useState<any>(null);
  const globalPatientSearchText = useGlobalInformationStore((state) => state.globalPatientSearchText);
  const setGlobalPatientSearchText = useGlobalInformationStore((state) => state.setGlobalPatientSearchText);
  const [fetchingPatientList, setFetchingPatientList] = useState<boolean>(false);
  const {patientFetchLoader , fetchMemberAndNavigateToProfile} = useHelperApiFunctions();

  const logout = () => {
    sessionStorage.setItem("forcedLogout", "true");
    if (!isUpload) {
      //clearing store data for hospital list and cm

      setShowLoader(true);
      appInsights.trackEvent({ name: `${session?.user?.email} manually logged out from tab ${idleTimer?.getTabId()}`, properties: { isLeader: idleTimer?.isLeader() } });
      appInsights.trackPageView({ name: "Logout" });
      appInsights.setAuthenticatedUserContext(sessionService?.getUser()?.email);
      authService.logout().subscribe({
        next: () => {
          setShowLoader(false);
          session.logout();
          appInsights.clearAuthenticatedUserContext();
          navigate(routeMap["home"]);
        },
        error: () => {
          setShowLoader(false);
        },
      });
    } else {
      setIsLogout(true);
    }
  };

  const menu = (
    <Menu style={{ width: "150px" }}>
      <Spin spinning={showLoader} indicator={<HealthemSpinner />}>
        <Menu.Item key="2" onClick={logout}>
          <span className="f16">Logout</span>
        </Menu.Item>
      </Spin>
    </Menu>
  );

  function handleGlobalPatientSearch({dropDownOption = {}} : any) {
    if (dropDownOption && dropDownOption.value) {
    setGlobalPatientSearchText(`${dropDownOption.title} - ${dropDownOption.subtitle}`);
    fetchMemberAndNavigateToProfile({patientId : dropDownOption.value});
    } else {
      setGlobalPatientSearchText('')
    }
  }

  const getMembersList = (inputString: string) => {
    const searchPatient = inputString?.trim();
    setSearchMembersInputString(searchPatient);
    if (searchPatient.length > 2) {
      setFetchingPatientList(true);
      membersService.fetchGlobalPatientSearchList({ searchText : searchPatient }).subscribe({
        next: (v) => {
          let response = v?.data?.data;
          response = response.map((option : any) => {return {
            value : option.patient_id,
            title : option.patient_name,
            subtitle : option.uId,
            sideHeader : option.patient_dob
          }})
          setMembersOptions(response);
          setFetchingPatientList(false);
        },
        error: (e) => {
          console.log(e);
          setFetchingPatientList(false);
        },
      });
    } else {
      setMembersOptions([]);
    }
  };

  const debouncedMemberSearch = debounce(getMembersList, 1000);

  return (
    <Row className="appHeader">
      <Col span={12} className="headerLeft">
        <img src={logo} alt={companyName} className="logo-healthEM" />
      </Col>
      <Col span={12} className="headerRight">
        {!showHeaderGlobalSearchAndNotification() && (
          <Spin spinning={patientFetchLoader} indicator={<HealthemSpinner />}>
            <div className="global_patient_search">
              <SearchOutlined style={{ fontSize: "18px" }} />
              <SimpleSelect
                onFocus={() => setMembersOptions([])}
                placeholder={"Enter Patient Name or Record id"}
                handleSelect={(value) => handleGlobalPatientSearch({ dropDownOption: find(membersOptions, { value: value }) })}
                value={globalPatientSearchText}
                options={membersOptions}
                loadingOptions={fetchingPatientList}
                customOption={GLOBAL_SEARCH_DROPDOWN_KEY}
                // dropdownStyle={{maxHeight: 170 }}
                bordered={false}
                onSearch={debouncedMemberSearch}
                noDataFound={
                  fetchingPatientList ? (
                    <Spin size="small" indicator={<HealthemSpinner />} />
                  ) : membersOptions.length > 0 ? null : searchMembersInputString?.length > 3 ? (
                    <DataNotFound message={NO_DATA_FOUND} />
                  ) : null
                }
              />
            </div>
          </Spin>
        )}
        {!showHeaderGlobalSearchAndNotification() && (
          <Button
            style={{ marginLeft: 8 }}
            type="default"
            onClick={() => {
              actionClickHandler({
                icon: Bell,
                alt: "Notification",
                id: "Notification",
              });
            }}
            shape="circle"
            icon={
              <Badge dot={newNotificationFlag} offset={[3, -3]}>
                <span>
                  <img src={BellIcon} alt="bell-icon" />
                </span>
              </Badge>
            }
            size="large"
            className="notification-btn"
          />
        )}
        <span className="userName">{userName}</span>
        <Dropdown overlay={menu} trigger={["click"]}>
          <Button type="default" shape="circle" icon={<h1>{userName?.charAt(0)}</h1>} size="large" className="salutation-btn m0 p24" />
        </Dropdown>
      </Col>
    </Row>
  );
};

export default Header;
